export const getOutletName = (outlet, filterData) => {
  const chain = filterData?.chains?.find((item) => item.chaKey === outlet.chaKey);
  const brand = filterData?.brands?.find((item) => item.braKey === outlet.braKey);
  const chainName = chain?.name || outlet.chaKey || "Outlet";
  return brand?.name ? `${brand.name} · ${chainName}` : chainName;
};

export const getRank = (value) => {
  const rank = String(value || "").trim().toUpperCase();
  if (rank === "STAR" || rank === "STARS") return "Star";
  if (rank === "CHALLENGE" || rank === "PUZZLE") return "Puzzle";
  if (rank === "WORKHORSE" || rank === "PLOWHORSE") return "Plowhorse";
  if (rank === "DOG" || rank === "DOGS") return "Dog";
  return "Unrated";
};

export const getItemIdentity = (item, fallback = "") =>
  JSON.stringify([
    String(item.itemRef ?? item.itemDescription ?? fallback),
    item.daypartId ?? item.daypartType ?? null,
  ]);

export const getItems = (outlets) =>
  outlets.flatMap((outlet, outletIndex) =>
    (Array.isArray(outlet.items) ? outlet.items : []).map((item, itemIndex) => ({
      ...item,
      _outletKey: outlet.chaKey || outlet.name || `outlet-${outletIndex}`,
      _itemKey: `${outlet.chaKey || outlet.name || outletIndex}-${getItemIdentity(item, itemIndex)}`,
      _rank: getRank(item.rank),
    }))
  );

export const getNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

export const getOutletMetric = (outlet, totalKey, itemKey) => {
  const total = Number(outlet.totals?.[totalKey]);
  if (Number.isFinite(total)) return total;
  return (outlet.items || []).reduce(
    (sum, item) => sum + getNumber(item[itemKey]),
    0
  );
};

export const formatMoney = (value) =>
  `QAR ${new Intl.NumberFormat("en", {
    maximumFractionDigits: 2,
  }).format(getNumber(value))}`;

export const formatNumber = (value, digits = 0) =>
  new Intl.NumberFormat("en", {
    maximumFractionDigits: digits,
  }).format(getNumber(value));

export const getMenuGroupName = (item, type) => {
  const name = type === "page"
    ? item.pageName
    : item.categoryName || item.category;
  return typeof name === "string" ? name.trim() : "";
};

export const getMenuGroupKey = (item, type) => {
  const name = getMenuGroupName(item, type);
  if (!name) return "ungrouped";
  return JSON.stringify([item[`${type}No`] ?? null, name]);
};

export const getMenuGroups = (items, type) => {
  if (!items.some((item) => getMenuGroupName(item, type))) return [];
  const groups = new Map();
  items.forEach((item) => {
    const key = getMenuGroupKey(item, type);
    const group = groups.get(key) || {
      key,
      name: getMenuGroupName(item, type) || "Unassigned",
      count: 0,
    };
    group.count += 1;
    groups.set(key, group);
  });
  return [...groups.values()];
};

export const filterMenuItems = (items, pageKey = "", categoryKey = "") =>
  items.filter(
    (item) =>
      (!pageKey || getMenuGroupKey(item, "page") === pageKey) &&
      (!categoryKey || getMenuGroupKey(item, "category") === categoryKey)
  );

export const getItemCategory = (item) =>
  [getMenuGroupName(item, "page"), getMenuGroupName(item, "category")]
    .filter(Boolean)
    .join(" / ") || "Unassigned";
